import SalonBusinessCpaTopicWorkspace from "./SalonBusinessCpaTopicWorkspace";

export default function SalonBusinessCpaPayroll() {
  return <SalonBusinessCpaTopicWorkspace topicKey="payroll" />;
}
